module.exports = __webpack_public_path__ + "img/2X.2.362ebad8.jpg";